import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

const sdgRemoved: string = 'sdgRemoved';

export const REMOVE_SLOT_CONTAINER: EffectFunction = ({ containerNode, options }: Adslot) => {
    containerNode.classList.add(sdgRemoved);

    //Set slotOptions.hideWhenEmpty if height set by Pub is on parentElement and Pub wants to remove SlotElement completely
    if (options.hideWhenEmpty) containerNode.parentElement?.classList.add(sdgRemoved);

    return () => {
        containerNode?.classList.remove(sdgRemoved);
        containerNode?.parentElement?.classList.remove(sdgRemoved);
    };
};
